'use client';

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

export interface RiskModalProps {
  open: boolean;
  onClose: () => void;
  /** 左侧按钮「反馈」点击 */
  onFeedback?: () => void;
  /** 右侧按钮「确认」点击 */
  onConfirm?: () => void;
  /** 标题，不传则使用文案配置 */
  title?: string;
  /** 描述文案，不传则使用文案配置 */
  description?: string;
}

const RiskModal: React.FC<RiskModalProps> = ({ open, onClose, onFeedback, onConfirm, title: titleProp, description: descriptionProp }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const title = titleProp ?? t('riskModal.title');
  const description = descriptionProp ?? t('riskModal.description');
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      closable={false}
      destroyOnHidden
      width={400}
      centered
      className="risk-dialog-modal"
      styles={{
        container: { borderRadius: 12 },
        body: { textAlign: 'center' as const },
      }}
    >
      <div className="flex flex-col items-center gap-4">
        <div className="w-12 h-12 rounded-full bg-[#fb6f06]/20 flex items-center justify-center shrink-0 mt-6">
          <div className="w-10 h-10 rounded-full bg-[#fb6f06] flex items-center justify-center">
            <span className="text-font-primary text-2xl font-bold leading-none">!</span>
          </div>
        </div>
        <div className="flex flex-col gap-2">
          <h3 className="text-lg font-semibold text-font-primary">{title}</h3>
          <p className="text-sm text-font-primary/70">{description}</p>
        </div>
        <div className="flex items-center gap-3 w-full mt-2">
          <Button
            variant="outline"
            className="flex-1 border-button-border bg-transparent text-font-primary hover:bg-background-card"
            onClick={() => {
              onClose();
              navigate('/feedback');
              onFeedback?.();
            }}
          >
            {t('riskModal.feedback')}
          </Button>
          <Button
            variant="orange"
            className="flex-1"
            onClick={() => {
              onConfirm?.();
              onClose();
            }}
          >
            {t('riskModal.confirm')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default RiskModal;
